var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"videoWrapper",staticClass:"video-on-scroll"},[(_vm.showVideo)?_c('video',{ref:"video",staticClass:"video",attrs:{"muted":"","loop":_vm.loop,"playsinline":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.videoSrc,"type":"video/mp4"}})]):_vm._e(),_vm._v(" "),(_vm.showImg)?_c('img',{attrs:{"src":_vm.imgSrc}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }